import React, { useState } from "react";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();

    if (email.trim() === "") {
      alert("Please enter your email");
      return;
    }

    alert(`Subscribed successfully: ${email}`);
    setEmail("");
  };

  return (
    <footer style={styles.footer}>

      <div style={styles.container}>

        {/* Quick Links */}
        <div style={styles.section}>
          <h3 style={styles.title}>Quick Links</h3>

          <ul style={styles.list}>
            <li><a href="/" style={styles.link}>Home</a></li>
            <li><a href="/about" style={styles.link}>About Us</a></li>
            <li><a href="/services" style={styles.link}>Services</a></li>
            <li><a href="/projects" style={styles.link}>Projects</a></li>
            <li><a href="/contact" style={styles.link}>Contact</a></li>
          </ul>
        </div>


        {/* Contact */}
        <div style={styles.section}>
          <h3 style={styles.title}>Contact</h3>

          <p style={styles.text}>
            📍 Kolkata, West Bengal, India
          </p>

          <p style={styles.text}>
            📞 +91 98765 43210
          </p>

          <p style={styles.text}>
            ✉ info@example.com
          </p>

          <p style={styles.text}>
            🕒 Mon - Fri : 9AM - 6PM
          </p>

        </div>


        {/* Newsletter */}
        <div style={styles.section}>

          <h3 style={styles.title}>
            Newsletter
          </h3>

          <p style={styles.text}>
            Subscribe to get latest updates and news.
          </p>


          <form 
            onSubmit={handleSubscribe}
            style={styles.form}
          >

            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e)=>setEmail(e.target.value)}
              style={styles.input}
            />


            <button 
              type="submit"
              style={styles.button}
            >
              Subscribe
            </button>


          </form>


          {/* Social Links */}

          <div style={styles.social}>

            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" style={styles.socialIcon}>f</a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)" style={styles.socialIcon}>𝕏</a>
            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" style={styles.socialIcon}>in</a>
            <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube" style={styles.socialIcon}>▶</a>

          </div>


        </div>


      </div>


      {/* Copyright */}

      <div style={styles.bottom}>

        <p>
          © {new Date().getFullYear()} Your Company Name.
          All Rights Reserved.
        </p>

      </div>


    </footer>
  );
};


const styles = {


  footer:{
    background:"#0f172a",
    color:"#ffffff",
    padding:"50px 20px 20px",
    fontFamily:"Inter, sans-serif"
  },


  container:{
    maxWidth:"1200px",
    margin:"auto",
    display:"grid",
    gridTemplateColumns:"repeat(auto-fit,minmax(250px,1fr))",
    gap:"35px"
  },


  section:{
    display:"flex",
    flexDirection:"column"
  },


  title:{
    fontSize:"20px",
    marginBottom:"20px",
    color:"#38bdf8"
  },


  list:{
    listStyle:"none",
    padding:0,
    margin:0
  },


  link:{
    color:"#cbd5e1",
    textDecoration:"none",
    display:"block",
    marginBottom:"12px",
    transition:"0.3s"
  },


  text:{
    color:"#cbd5e1",
    fontSize:"14px",
    lineHeight:"1.7",
    margin:"5px 0"
  },


  form:{
    display:"flex",
    marginTop:"15px"
  },


  input:{
    flex:1,
    padding:"12px",
    border:"none",
    outline:"none",
    borderRadius:"5px 0 0 5px",
    fontSize:"14px"
  },


  button:{
    padding:"12px 18px",
    border:"none",
    background:"#38bdf8",
    color:"#0f172a",
    fontWeight:"600",
    cursor:"pointer",
    borderRadius:"0 5px 5px 0"
  },


  social:{
    display:"flex",
    gap:"12px",
    marginTop:"20px"
  },


  socialIcon:{
    width:"35px",
    height:"35px",
    borderRadius:"50%",
    background:"#1e293b",
    color:"#fff",
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    textDecoration:"none",
    fontWeight:"bold"
  },


  bottom:{
    borderTop:"1px solid #334155",
    marginTop:"40px",
    paddingTop:"20px",
    textAlign:"center",
    color:"#94a3b8",
    fontSize:"14px"
  }

};


export default Footer;